import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { utils } from 'ethers';

function tokenImageSource(address) {
    const checkSumAddress = utils.getAddress(address)
    return address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
        ? `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png`
        : `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${checkSumAddress}/logo.png`
}

const Token = ({ address, size=72 }) => {
    return <Avatar src={address && tokenImageSource(address)} style={{ height: size, width: size, display: 'inline-block' }} />
}

export default Token